


























































































import Vue from 'vue'
import _ from 'lodash'
import { GET_CURRENT_USER_ID, GET_SELECTED_UI_LANGUAGE } from '@/store/getter-types'
import { DxColumn, DxDataGrid, DxScrolling, DxSelection } from 'devextreme-vue/data-grid'
import {
  FETCH_ADDRESS_FELD_LIST,
  FETCH_SEARCH_PRODUCT_LIST
} from '@/store/action-types'
import AddressWindow from '@/components/master-data/address/AddressWindow.vue'
import {
  AdressZusatzfelderType,
  AdressZusatzfelderTypesResponse, ProductSearchResponse
} from '@/types/service-response'
import { ProductSearchRequest } from '@/types/payload'
import { ProductSearchResult } from '@/model/project/ProductSearchResult'

interface ComponentData {
  tableHeight: string,
  loading: boolean
  showDialog: boolean
  productIdList: number[]

  schluessel: string
  bezeichnung: string
  lagercode: string
  gruppe: string
  barcode: string
  klProduktivNr: string
  verfuegbar: boolean
  nurBevorzugteLager: boolean
  nurAuslierfortSyzSRO: boolean
  gesperrteAusblenden: boolean
  verfuegbarReservationen: boolean
  verfuegbarBestellungen: boolean

  productList: ProductSearchResult[]
  isDetailButtonDisabled: boolean
  feldList: AdressZusatzfelderType[]
  operatorList: any[]
  boolOperatorNextList: any[]
  additionalFilterList: any[]
}

export default Vue.extend({
  name: 'ProductSearchPage',

  components: {
    AddressWindow,
    DxDataGrid,
    DxColumn,
    DxScrolling,
    DxSelection
  },

  props: {
    productGroupId: Number
  },

  data (): ComponentData {
    return {
      tableHeight: '',
      loading: false,
      showDialog: false,
      productIdList: [],

      schluessel: '',
      bezeichnung: '',
      lagercode: '',
      gruppe: '',
      barcode: '',
      klProduktivNr: '',
      verfuegbar: false,
      nurBevorzugteLager: false,
      nurAuslierfortSyzSRO: false,
      gesperrteAusblenden: false,
      verfuegbarReservationen: false,
      verfuegbarBestellungen: false,

      productList: [],
      isDetailButtonDisabled: true,
      feldList: [],
      operatorList: [
        {id: 1, name: '='},
        {id: 2, name: 'Like'},
        {id: 3, name: 'grosser'},
        {id: 4, name: 'grosser gleich'},
        {id: 5, name: 'kleiner'},
        {id: 6, name: 'kleiner gleich'},
        {id: 7, name: 'nicht gleich'},
        {id: 8, name: 'nicht wie'}
      ],
      boolOperatorNextList: [
        {id: 0, name: ''},
        {id: 1, name: 'UND'},
        {id: 2, name: 'ODER'}
      ],
      additionalFilterList: [
        {id: 1, feld: null, operator: null, inhalt: '', boolOperatorNext: null}
      ]
    }
  },

  watch: {
    $route (newVal: any): void {
      if(newVal.query.create) {
        this.productIdList = [0]
        this.showDialog = true
      }

      if(this.productGroupId) {
        //this.adressgruppe = this.productGroupId
      } else {
        //this.adressgruppe = undefined
      }
    }
  },

  computed: {
    currentUserId (): number {
      return this.$store.getters[GET_CURRENT_USER_ID]
    },

    selectedLanguageId (): number {
      return this.$store.getters[GET_SELECTED_UI_LANGUAGE].syzId
    },
  },

  methods: {
    onChangeFeld (index: number, item: any): void {
      if(item === 0) {
        this.additionalFilterList[index].feld = null
        this.additionalFilterList[index].operator = null
        this.additionalFilterList[index].inhalt = ''
        this.additionalFilterList[index].boolOperatorNext = 0
        this.additionalFilterList.splice(index + 1, this.additionalFilterList.length)
      }
    },

    onChangeAdditional (index: number, item: any): void {
      if(item === 0) {
        if(this.additionalFilterList && this.additionalFilterList[index + 1]) {
          this.additionalFilterList.splice(index + 1, 1)
        }
      } else {
        if(this.additionalFilterList && !this.additionalFilterList[index + 1]) {
          const highId = _.maxBy(this.additionalFilterList, 'id')
          this.additionalFilterList.push({id: highId.id + 1, feld: null, operator: null, inhalt: '', boolOperatorNext: 0})
        }
      }
    },

    startCreate (): void {
      this.productIdList = [0]
    },

    productCreated (id: number): void {
      this.productIdList = [id]
    },

    productEdited (): void {
      this.searchProduct()
    },

    productDeleted (id: number) : void {
      this.productIdList.splice(this.productIdList.indexOf(id), 1)
      if(this.productIdList.length === 0) {
        this.showDialog = false
        this.searchProduct()
      } else {
        this.searchProduct()
      }
    },

    onCloseDialog (): void {
      this.showDialog = false
      this.productIdList = []
      if(this.productGroupId) {
        this.$router.push({ path: `/product/${this.productGroupId}`})
      } else {
        this.$router.push({ path: '/product'})
      }
    },

    onSearchButtonClick (): void {
      this.productList = []
      this.searchProduct()
    },

    onSelectionChanged (data: any) {
      this.isDetailButtonDisabled = data.selectedRowKeys.length <= 0
    },

    rowDblClick(event: any): void {
      this.productIdList.push(event.data.id)
      this.showDialog = true
    },

    onDetailClick (): void {
      //@ts-ignore
      const selectedProductIdList: number[] = this.$refs.dataGrid.instance.getSelectedRowKeys()

      if(selectedProductIdList.length > 0) {
        this.productIdList = selectedProductIdList
        this.showDialog = true
      }
    },

    onResize (): void {
      if(this.$refs.filter && this.$vuetify.breakpoint.mdAndUp) {
        const vh = window.innerHeight
        if(vh > 500) {
          const height = (this.$refs.filter as HTMLElement).clientHeight
          this.tableHeight = `height: calc(${vh}px - 105px - ${height}px)`
        } else {
          this.tableHeight = '300px'
        }
      } else {
        this.tableHeight = '300px'
      }
    },

    async searchProduct (): Promise<void> {
      const payload: ProductSearchRequest = {
        Schluessel: this.schluessel,
        Bezeichnung: this.bezeichnung,
        Lagercode: this.lagercode,
        Gruppe: this.gruppe,
        Barcode: this.barcode,
        KlProduktivNr: this.klProduktivNr,
        Verfuegbar: this.verfuegbar,
        NurBevorzugteLager: this.nurBevorzugteLager,
        NurAuslierfortSyzSRO: this.nurAuslierfortSyzSRO,
        GesperrteAusblenden: this.gesperrteAusblenden,
        VerfuegbarReservationen: this.verfuegbarReservationen,
        VerfuegbarBestellungen: this.verfuegbarBestellungen,
        Sprache: this.selectedLanguageId,
        Mitarbeiter: this.currentUserId
      }

      try {
        this.loading = true
        const response: ProductSearchResponse = await this.$store.dispatch(FETCH_SEARCH_PRODUCT_LIST, payload)
        if(!response.IsError && response.Results) {
          this.productList = ProductSearchResult.createFromResponse(response.Results)
        }
        this.loading = false
      } catch {
        this.loading = false
      }
    },

    async fetchFeldList (): Promise<void> {
      try {
        const response: AdressZusatzfelderTypesResponse = await this.$store.dispatch(FETCH_ADDRESS_FELD_LIST)
        if(!response.IsError) {
          this.feldList = response.Data
          this.feldList.unshift({
            ID: 0,
            Bezeichnung: ''
          })
        }
      } catch {
      }
    }

  },

  async mounted (): Promise<void> {
    if(this.$route.query.create) {
      this.productIdList = [0]
      this.showDialog = true
    }

    if(this.productGroupId) {
      //this.adressgruppe = this.productGroupId
    }

    this.fetchFeldList()
  }
})
